import { render, staticRenderFns } from "./ManuscriptBackup.vue?vue&type=template&id=b95356b0&scoped=true&"
import script from "./ManuscriptBackup.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptBackup.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptBackup.vue?vue&type=style&index=0&id=b95356b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95356b0",
  null
  
)

export default component.exports